import { Flex, Icon, SimpleInput, Typography } from '@aloft/toolkit-sui';

import { Controller, useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';
import { getCostQualityRange } from '../../modules/analysis/modals/objectiveEdit/getCostQualityRange.tsx';
import { DepreciationToggle } from './DepreciationToggle.tsx';

const UAD_QUALITY_KEYS = ['1', '2', '3', '4', '5', '6'] as const;

const qualityRange = getCostQualityRange('singleFamilyResidence');

const CraftsmanQualityRow = ({ uadKey }: { uadKey: string }) => {
  const { control } = useZodFormContext();
  const value = useWatch({ name: `uadToCraftsmanQuality.${uadKey}`, control });
  const numValue = parseFloat(value);
  const label = Number.isNaN(numValue) ? '' : qualityRange.getLabel(numValue);
  const displayLabel = label.replace(/ Standard$/, '');

  return (
    <Flex alignItems="center" gap="2rem">
      <Typography variant="h3" color="textSecondary" __dangerDoNotUseSx={{ minWidth: '1.5rem' }}>
        Q{uadKey}
      </Typography>
      <Icon icon="arrow-right" size="lg" color="textSecondary" />
      <Controller
        name={`uadToCraftsmanQuality.${uadKey}`}
        control={control}
        render={({ field }) => (
          <SimpleInput
            size="md"
            type="number"
            precision={1}
            width="5rem"
            {...field}
            value={field.value?.toString() ?? ''}
          />
        )}
      />
      <Typography variant="body1" __dangerDoNotUseSx={{ minWidth: '3.75rem' }}>
        {displayLabel || 'None'}
      </Typography>
    </Flex>
  );
};

export const DefaultCraftsmanQuality = () => (
  <Flex flexDirection="column" gap="1.5rem" width="100%">
    <Flex flexDirection="column" gap="1rem" width="100%">
      <Typography variant="h3">
        Set default Craftsman Quality conversions, from UAD Quality:
      </Typography>
      <Flex flexDirection="column" gap="0.5rem" alignItems="center" width="100%">
        {UAD_QUALITY_KEYS.map((key) => (
          <CraftsmanQualityRow key={key} uadKey={key} />
        ))}
      </Flex>
    </Flex>
    <DepreciationToggle
      question="Show Craftsman Quality on the feature grid?"
      trueLabel="Yes"
      falseLabel="No"
      fieldName="showCraftsmanQualityOnGrid"
      forceHorizontal
      trueFirst
    />
  </Flex>
);

